import Button from 'components/Button';
import Error from 'components/Error';
import FormTextField from 'components/Form/TextField';

import { useForm } from 'utils/forms';

interface FormProps {
  password: string;
  confirm_password: string;
  token: string;
}

interface ResetPasswordFormProps {
  onSave: (data: FormProps) => Promise<any>;
  token: string;
}

const ResetPasswordForm = ({ onSave, token }: ResetPasswordFormProps) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
    setError
  } = useForm<FormProps>({
    defaultValues: { password: '', confirm_password: '', token: token }
  });

  const onSubmit = (data: FormProps) => {
    onSave(data).catch(
      (errors) => errors.setFormErrors && errors.setFormErrors(setError)
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-8">
      <div className="flex w-[300px] flex-col gap-6">
        {errors.root?.serverError.message && (
          <Error>{errors.root?.serverError.message}</Error>
        )}

        <FormTextField
          name="password"
          control={control}
          fieldProps={{
            label: 'Password',
            type: 'password',
            placeholder: 'Enter Password',
            error: !!errors.password,
            helperText: errors.password?.message
          }}
        />

        <FormTextField
          name="confirm_password"
          control={control}
          fieldProps={{
            label: 'Confirm password',
            type: 'password',
            placeholder: 'Confirm Password',
            error: !!errors.confirm_password,
            helperText: errors.confirm_password?.message
          }}
        />
      </div>
      <Button type="submit" variant="contained">
        Reset password
      </Button>
    </form>
  );
};
export default ResetPasswordForm;
